var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallAPersonTab1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.871 17.0372C21.2571 17.0372 19.7016 16.7779 18.2432 16.2983C17.796 16.1557 17.284 16.2594 16.9275 16.6159L14.0757 19.4742C10.4007 17.6076 7.40621 14.6066 5.53306 10.9381L8.38491 8.07979C8.74139 7.72331 8.84509 7.21127 8.7025 6.76405C8.22287 5.30572 7.96361 3.74368 7.96361 2.12979C7.96361 1.41035 7.38676 0.833496 6.66732 0.833496H2.13028C1.41084 0.833496 0.833984 1.41035 0.833984 2.12979C0.833984 14.302 10.6988 24.1668 22.871 24.1668C23.5905 24.1668 24.1673 23.59 24.1673 22.8705V18.3335C24.1673 17.614 23.5905 17.0372 22.871 17.0372Z",
    fill: "#2760A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallAPersonTab1);
export default __webpack_public_path__ + "static/media/call-a-person-tab-1.ae1d386ad9c1969dc3dd81a588bf4024.svg";
export { ForwardRef as ReactComponent };